<div class="warning" *ngIf="userHasNotFranceTimezone">
  Horaires affichées dans le fuseau horaire de Paris <strong>(UTC+2)</strong>.
</div>
